<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>申请好友功能</span>
      </div>

      <el-form>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>触发等级</span>
              </div>
              <el-form :inline="true">
                <el-form-item label="等级范围">
                  <el-input v-model.number="basic.level.start" placeholder="开始等级" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="basic.level.end" placeholder="结束等级" />
                </el-form-item>
                <el-form-item label="触发概率">
                  <el-input v-model.number="basic.level.rate" placeholder="触发概率" />
                </el-form-item>
              </el-form>
            </el-card>

          </el-col>
          <el-col :span="24" class="mtop">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>完成新手引导加好友延迟</span>
              </div>
              <el-form :inline="true">
                <el-form-item label="随机值范围">
                  <el-input v-model.number="basic.add.start" placeholder="开始" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="basic.add.end" placeholder="结束" />
                </el-form-item>
              </el-form>
            </el-card>

          </el-col>
          <el-col :span="24" class="mtop">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>消耗体力</span>
              </div>
              <el-form :inline="true">
                <el-form-item label="体力范围">
                  <el-input v-model.number="basic.spins.start" placeholder="开始" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="basic.spins.end" placeholder="结束" />
                </el-form-item>
              </el-form>
            </el-card>

          </el-col>
          <el-col :span="24" class="mtop">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>加好友限制</span>
              </div>
              <el-form :inline="true">
                <el-form-item label="最大等级[大于这个等级不加]">
                  <el-input v-model.number="basic.limit.maxLevel" placeholder="开始等级" />
                </el-form-item>
                <el-form-item label="最大机器人数">
                  <el-input v-model.number="basic.limit.maxFriend" placeholder="最大机器人数" />
                </el-form-item>
              </el-form>
            </el-card>

          </el-col>
        </el-row>
        <el-button class="mtop" type="primary" @click="onSubmit()">保存</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'

export default {
  name: 'RobotAdd',
  data() {
    return {
      key: 'ROBOT_FRIEND_CONFIG:ADD',
      basic: {
        limit: {
          maxLevel: 1,
          maxFriend: 2
        },
        add: {
          start: 0,
          end: 0
        },
        spins: {
          start: 0,
          end: 0
        },
        level: {
          start: 0,
          end: 0,
          rate: 0
        }
      }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    getTables() {
      getCommonCfg({ name: this.key }).then(res => {
        this.basic = res.data
      })
    },
    onSubmit() {
      const data = JSON.stringify(this.basic)
      updateCommonCfg({ data: data, name: this.key }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
.mtop{
  margin-top: 20px;
}
</style>
